<div class="fc-detail-form">
  <div class="fc-detail-form-header">
    <span class="material-icons fc-detail-form-icon">precision_manufacturing</span>
    <h3 class="fc-detail-form-title">{{ machineForm.controls.id.value ? 'Edit Machine' : 'Add Machine' }}</h3>
  </div>

  <form [formGroup]="machineForm" (ngSubmit)="onSubmit()" class="fc-form-grid">
    <input formControlName="id" type="hidden" />

    <mat-form-field appearance="outline">
      <mat-label>Serial Number</mat-label>
      <input matInput formControlName="serialNumber" required />
      <mat-error *ngIf="machineForm.controls?.serialNumber?.hasError('required')">Required</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Name</mat-label>
      <input matInput formControlName="name" required />
      <mat-error *ngIf="machineForm.controls?.name?.hasError('required')">Required</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Customer</mat-label>
      <mat-select formControlName="customerId" required>
        <mat-option *ngFor="let customer of customers" [value]="customer.id">{{ customer.name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Function</mat-label>
      <mat-select formControlName="function" required>
        <mat-option *ngFor="let item of functions" [value]="item">{{ functonLabel[item] }}</mat-option>
      </mat-select>
      <mat-error *ngIf="machineForm.controls.function.hasError('required')">Required</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Operator</mat-label>
      <input matInput formControlName="operator" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Year</mat-label>
      <input matInput formControlName="year" type="number" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Type</mat-label>
      <input matInput formControlName="machineType" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="fc-field-full">
      <mat-label>Labels</mat-label>
      <mat-chip-list #chipList aria-label="Label selection" formControlName="labels">
        <mat-chip *ngFor="let label of machineForm.value.labels" (removed)="remove(label)">
          {{ label.type }}:{{ label.code }}
          <button class="fc-chip-remove" matChipRemove><mat-icon>cancel</mat-icon></button>
        </mat-chip>
        <input
          placeholder="New label (type:label)…"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur"
          (matChipInputTokenEnd)="add($event)"
        />
      </mat-chip-list>
    </mat-form-field>

    <mat-form-field appearance="outline" class="fc-field-full">
      <ngx-mat-file-input formControlName="imageBin" accept="image"></ngx-mat-file-input>
      <mat-hint>Image/logo [max {{ imgaMaxSize }} Mb]</mat-hint>
      <mat-error *ngIf="machineForm.controls.imageBin.hasError('maxSize')">File too large</mat-error>
    </mat-form-field>

    <mat-checkbox *ngIf="machineForm.controls?.id" class="fc-field-full" formControlName="deleteImg">Delete image</mat-checkbox>

    <div class="fc-form-actions">
      <button type="reset" class="fc-btn fc-btn--ghost" (click)="clear()">Clear</button>
      <button type="submit" class="fc-btn fc-btn--primary" [disabled]="!machineForm.valid">Save</button>
    </div>

    <p class="fc-form-error" *ngIf="machineForm.errors?.serialNumberTaken">This serial number is already taken.</p>
  </form>
</div>
